import React, { useState, useEffect } from "react";

// import "babel-polyfill";
import { Link } from "@reach/router";
import useGame from "../../hooks/useGame";
import { navigate } from "@reach/router";
import styled from "styled-components";
import {
  TopicsContainer,
  LevelListContainer,
  GameSelectionContainer
} from "../../styled_components/containers";
import {
  Button,
  GreenButton,
  GreyedButton
} from "../../../../globals/components/button";
import Checkbox from "../../../../globals/components/Checkbox";
import { Loading } from "../../../../globals/components/loading";
import useTopics from "../../hooks/useTopics";
import MultiplyDivide from "../../applications/MultiplyDivide/Practice.js";
import Spelling from "../../applications/Spelling/Practice.js";
import Addition from "../../applications/Addition/Practice.js";
import Fractions from "../../applications/Fractions/Practice.js";
import Grammar from "../../applications/Grammar/Practice.js";
import Geometry from "../../applications/Geometry/Practice.js";
import Measurements from "../../applications/Measurements/Practice.js";
import PlaceValue from "../../applications/NumPlace/Practice.js";
import Statistics from "../../applications/Statistics/Practice.js";
import Numerals from "../../applications/Numerals/Practice.js";
import Algebra from "../../applications/Algebra/Practice.js";
import Phonics from "../../applications/Phonics/Practice.js";
import Numbersense from "../../applications/NumberSense/Practice.js";
import Ratios from "../../applications/Ratios/Practice.js";

//import RatingStats from "../../hooks/useRatingStats";
import ReactTooltip from 'react-tooltip';
import { debug } from "util";
import { Scale } from 'react-scaling';

import Papa from "papaparse";
import additionsExtraQuestions from '../../assets/Addition/ExtraQuestions/additions_extraquestions.csv';
import numplaceExtraQuestions from '../../assets/NumberAndPlace/ExtraQuestions/numplace_extraquestions.csv';
import multiplicationExtraQuestions from '../../assets/Multiplication/ExtraQuestions/mult_extraquestions.csv';

export default function TestAssignment({ id, ...props }) {
  const game = useGame(id);
  console.log(game);
  const { topics } = useTopics({ game_type: game.game_type }, game);
  const [selectedLevel, setSelectedLevel] = useState([]);
  const [selectedLevelID, setSelectedLevelID] = useState(1);
  const [gameStatus, setGameStatus] = useState(props.startImmediately || false);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [addedExtraAdditions, setAddedExtraAdditions] = useState(false);
  console.log(props);


  const levels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  function onLevelSelect(id) {

    if (game.service_key == "addition" && addedExtraAdditions == false){
      console.log("level selected");
      console.log(topics);
      //add into the first level the extra additions topics
      AddExtraTopics();
    }else{
      setAddedExtraAdditions(true);
    }

    const topicsSelected = topics[id];

    console.log(topicsSelected);
    if (topicsSelected == undefined){
      onLevelSelect(1);
    }else{
      //sort alphabetically
      topicsSelected.sort((a, b) => a.topicname.toLowerCase().localeCompare(b.topicname.toLowerCase(),'en', {numeric: true}))
      setSelectedLevelID(id);
      setSelectedLevel(topicsSelected);
      console.log(topics);
      console.log(topicsSelected);
      console.log(id);
    }
  }


  useEffect(() => {
    if (topics != undefined){
      if (game.service_key == "addition" && addedExtraAdditions == false){
        console.log("level selected");
        console.log(topics);
        //add into the first level the extra additions topics
        AddExtraTopics();
      }else{
        setAddedExtraAdditions(true);
        setSelectedTopics(props.topics);
      }

      
    }

  }, [topics]);

  function onTopicsSelect(id) {
    setSelectedTopics([...selectedTopics, id]);
  }

  function HasTopicAlready(tquestion, questionslist){
    for (let i = 0; i < questionslist.length; i++) {
      const element = questionslist[i];
      if (element.topic_key == tquestion.topic_key){
        return true;
      }
    }
    return false;
  }

  function AddExtraTopics(){
    console.log(additionsExtraQuestions);
    //import from CSV
    Papa.parse(additionsExtraQuestions, {
      download: true,
      header: true,
      complete: function (results) {
        setSelectedTopics(props.topics);
        console.log("Extra Questions:");
        console.log(results.data)
        let addMe = [];
          for (let x = 0; x < results.data.length; x++) {
            const extraQ = results.data[x];
            if (HasTopicAlready(extraQ, addMe) == false && extraQ.topic_key != undefined){
              let ntopic = {
              difficulty : extraQ.difficulty,
              topic_key : extraQ.topic_key,
              id: extraQ.topic_key,
              name : extraQ.topic,
              topicname: extraQ.topic};
              addMe.push(ntopic);
            }
          }
        console.log("ALLTOPICS:");
        console.log(addMe);
        for (let i = 0; i < addMe.length; i++) {
          topics[parseInt(addMe[i].difficulty)].push(addMe[i]);
        }
        setAddedExtraAdditions(true);
        console.log("done adding extra questions");
      },
    });
    
    
  }

  function onTopicsUnselect(id) {
    setSelectedTopics(
      selectedTopics.filter(function (value) {
        return value !== id;
      })
    );
    setSelectAll(false);
  }

  function launchGame() {
    setGameStatus(true);
  }

  function endGame() {
    console.log("endgame");
    setGameStatus(false);
    props.onEnd && props.onEnd();
  }

  useEffect(() => {
    if (selectAll) {
      let topicIds = [];
      selectedLevel.map(topic => {
        topicIds.push(topic.id);
      });
      setSelectedTopics(
        [...selectedTopics, topicIds].reduce((acc, val) => acc.concat(val), [])
      );
    } else {
      var result = 0;
      selectedLevel.forEach(function (item) {
        if (selectedTopics.includes(item.id)) {
          result++;
        }
      });
      if (result === selectedLevel.length) {
        setSelectedTopics(
          selectedTopics.filter(function (element) {
            return (
              selectedLevel
                .reduce((acc, topic) => {
                  return [...acc, topic.id];
                }, [])
                .indexOf(element) === -1
            );
          })
        );
      } else {
      }
    }
  }, [selectAll]);

  useEffect(() => {
    if (selectedLevel != undefined) {
      var result = 0;
      selectedLevel.forEach(function (item) {
        if (selectedTopics.includes(item.id)) {
          result++;
        }
      });
      if (result === selectedLevel.length) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }
    }
  }, [selectedLevel]);

  const gameComponent = () => {
    switch (game.service_key) {
      case "timetables":
        return (
          <MultiplyDivide
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            TestingAssignment={true}
            topicKeys={props.topics}

          /*gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                  return [
                      ...acc,
                      ...topicArr.filter(topic => {
                          return selectedTopics.indexOf(topic.id) > -1;
                      })
                  ];
              },
              []
          )}*/
          />
        );
      case "spelling":
        return (
          <Spelling
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            customlist={props.customlist}
            TestingAssignment={true}
            topicKeys={props.topics}


          />
        );
      case "addition":
        return (
          <Addition
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            TestingAssignment={true}
            topicKeys={props.topics}

            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              }, []
            )}
          />
        );
      case "fractions":
        return (
          <Fractions
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            TestingAssignment={true}
            topicKeys={props.topics}

            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              },
              []
            )}
          />
        );
      case "grammar":
        return (
          <Grammar
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            TestingAssignment={true}
            topicKeys={props.topics}
            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              }, []
            )}
          />
        );
      case "geometry":
        return (
          <Geometry
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            TestingAssignment={true}
            topicKeys={props.topics}

            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              }, []
            )}
          />
        );
      case "measurement":
        return (
          <Measurements
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            TestingAssignment={true}
            topicKeys={props.topics}

            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              }, []
            )}
          />
        );
      case "numplace":
        return (
          <PlaceValue
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            TestingAssignment={true}
            topicKeys={props.topics}

            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              }, []
            )}
          />
        );
      case "statistics":
        return (
          <Statistics
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            TestingAssignment={true}
            topicKeys={props.topics}

            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              }, []
            )}
          />
        );
      case "romannumerals":
        return (
          <Numerals
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            TestingAssignment={true}
            topicKeys={props.topics}

            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => { return selectedTopics.indexOf(topic.id) > -1; })
                ];
              }, []
            )}
          />
        );
      case "algebra":
        return (
          <Algebra
            homework_id={props.homework_id}
            onBack={() => endGame()}
            gameType={game.game_type}
            topics={selectedTopics}
            gameBackground={game.practice_background}
            level={selectedLevelID}
            gameData={game}
            TestingAssignment={true}
            topicKeys={props.topics}

            gameCalculations={Object.entries(topics).reduce(
              (acc, [level, topicArr]) => {
                return [
                  ...acc,
                  ...topicArr.filter(topic => {
                    return selectedTopics.indexOf(topic.id) > -1;
                  })
                ];
              },
              []
            )}
          />
        );
        case "phonics":
          return (
            <Phonics
              homework_id={props.homework_id}
              onBack={() => endGame()}
              gameType={game.game_type}
              topics={selectedTopics}
              gameBackground={game.practice_background}
              level={selectedLevelID}
              gameData={game}
              TestingAssignment={true}
              topicKeys={props.topics}

              gameCalculations={Object.entries(topics).reduce(
                (acc, [level, topicArr]) => {
                  return [
                    ...acc,
                    ...topicArr.filter(topic => {
                      return selectedTopics.indexOf(topic.id) > -1;
                    })
                  ];
                },
                []
              )}
            />
          );
          case "numbersense":
            return (
              <Numbersense
                homework_id={props.homework_id}
                onBack={() => endGame()}
                gameType={game.game_type}
                topics={selectedTopics}
                gameBackground={game.practice_background}
                level={selectedLevelID}
                gameData={game}
                TestingAssignment={true}
                topicKeys={props.topics}

                gameCalculations={Object.entries(topics).reduce(
                  (acc, [level, topicArr]) => {
                    return [
                      ...acc,
                      ...topicArr.filter(topic => {
                        return selectedTopics.indexOf(topic.id) > -1;
                      })
                    ];
                  },
                  []
                )}
              />
            );
            case "ratioprop":
              return (
                <Ratios
                  homework_id={props.homework_id}
                  onBack={() => endGame()}
                  gameType={game.game_type}
                  topics={selectedTopics}
                  gameBackground={game.practice_background}
                  level={selectedLevelID}
                  gameData={game}
                  TestingAssignment={true}
                  topicKeys={props.topics}

                  gameCalculations={Object.entries(topics).reduce(
                    (acc, [level, topicArr]) => {
                      return [
                        ...acc,
                        ...topicArr.filter(topic => {
                          return selectedTopics.indexOf(topic.id) > -1;
                        })
                      ];
                    },
                    []
                  )}
                />
              );
      default:
        return null;
    }
  }
  return (
    <>
      {gameStatus && addedExtraAdditions && topics ? (
        gameComponent()
      ) : (
          <TopicsContainer lv={selectedLevel}>
            {selectedLevel != undefined ? (

              <Scale scaleTo={1720}>
                <div>
                  <GameSelectionContainer>
                    <h1>Select Topics to Practise</h1>
                    {selectedLevel.length > 0 && (
                      <Checkbox
                        label="Select All"
                        bold={true}
                        onChange={e => {
                          if (e.target.checked === true) {
                            setSelectAll(true);
                          } else {
                            setSelectAll(false);
                          }
                        }}
                        checked={selectAll}
                      />
                    )}
                    {selectedLevel.length > 0 &&
                      selectedLevel.map(topic => {
                        return (
                          <Checkbox
                            label={topic.topicname}
                            onChange={e => {
                              if (e.target.checked === true) {
                                onTopicsSelect(topic.id);
                              } else {
                                onTopicsUnselect(topic.id);
                              }
                            }}
                            checked={
                              selectedTopics.findIndex(x => x === topic.id) !== -1
                                ? true
                                : false
                            }
                          />
                        );
                      })}
                      {selectedLevel.length == 0 &&
                      <h2>Downloading Topics... (Refresh if not downloaded after 2 minutes)</h2>}
                  </GameSelectionContainer>
                  <div>
                    {selectedTopics.length > 0 ? (
                      <GreenButton
                        style={{ width: "20%" }}
                        onClick={() => launchGame()}
                      >
                        Play
                                </GreenButton>
                    ) : (
                        <GreyedButton data-tip="You need to add a topic to practice" style={{ width: "20%" }}>Play</GreyedButton>
                      )}
                  </div>
                </div>
              </Scale>
            ) : (
                <div>
                </div>
              )}
              
              <Buttonz onClick={() =>{navigate(".")}}>Back</Buttonz>
          </TopicsContainer>
        )}
    </>
  );
}

const Buttonz = styled.button`
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  width: 20%;
  border: 2px solid #e88f12;
  color: #fff;
  user-select: none;
  padding: 0.5em;
  margin: -0.5em 0;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`

const Tools = styled(ReactTooltip)`
  font-size: 20px !important;
  background-color: #543171FF !important;
  `

const LevelButton = styled(Button)`
    text-align: center;
    width: 10%;
    height: 70px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: ${props => (props.active ? "#673b8b," : "rgb(234, 146, 19)")};
    background: ${props =>
    props.active
      ? "linear-gradient(0deg, #673b8b, #683d8c)"
      : "linear-gradient(0deg,rgba(234, 146, 19, 1) 0%,rgba(255, 186, 32, 1) 100%)"};
    border: 2px solid ${props => (props.active ? "#673b8b" : "#e88f12")};

    padding: 0.5em;
    box-sizing: border-box;
    border-radius: 0.25em;
    font-size: 3em;
    cursor: ${props => (props.active ? "pointer" : "")};
    @media (min-width: 1025px) and (max-width: 1440px) {
        font-size: 2.5em;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin-bottom: 0;
    }
`;
